import { render, staticRenderFns } from "./Cashier.vue?vue&type=template&id=497f3b70&scoped=true&"
import script from "./Cashier.vue?vue&type=script&lang=js&"
export * from "./Cashier.vue?vue&type=script&lang=js&"
import style0 from "./Cashier.vue?vue&type=style&index=0&id=497f3b70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f3b70",
  null
  
)

export default component.exports